<div *ngIf="showRequest" class="read-only-content">
  <!--workcompletion-->
  <h2 class="sectionTitle">{{ 'FRONT_USER.WORK_COMPLETION_FORM.WORK_COMPLETION_REQUEST' | translate }}</h2>
  <!--load shipyard request read only-->

  <div  *ngIf="CurrServiceTypeId!=serviceType.FiberGlass">
    <!-- <app-request-details [baseRequest]="baseRequestDTO"></app-request-details> -->
  </div>

  <div *ngIf="CurrServiceTypeId==serviceType.Repair">
    <app-create-repair-request></app-create-repair-request>
  </div>
  <div *ngIf="CurrServiceTypeId==serviceType.NonDestructiveTestingWork">
    <app-non-destructive-testing-work></app-non-destructive-testing-work>
  </div>
  <div *ngIf="CurrServiceTypeId==serviceType.HardnessTest">
    <app-create-hardness-test-request></app-create-hardness-test-request>
  </div>
  <div *ngIf="CurrServiceTypeId==serviceType.DynamicBalancing">
    <app-dynamic-balancing-request></app-dynamic-balancing-request>
  </div>
  <div *ngIf="CurrServiceTypeId==serviceType.FloatingCranes">
    <app-create-floating-cranes-request></app-create-floating-cranes-request>
  </div>
  <div *ngIf="CurrServiceTypeId==serviceType.FiberGlass">
      <app-admin-decision [IsReadOnly]="true"></app-admin-decision>
    <!-- <app-fibberglass-request></app-fibberglass-request> -->
  </div>
  <div *ngIf="CurrServiceTypeId==serviceType.Salvage">
    <app-salvage-request></app-salvage-request>
  </div>


  <div *ngIf="isAdditional">
      <app-additional-work [IsCompletionView]="isReadOnly"  ></app-additional-work>
    </div>
</div>
<div class=" " *ngIf="showRequest">
  <form [formGroup]="workCompletionForm" [class.read-only-content]="viewMode" >
      <fieldset [disabled]="viewMode">
    <div class="form-container">
      <h4 class="section-title">{{ 'FRONT_USER.WORK_COMPLETION_FORM.WORK_COMPLETION_REQUEST' | translate }}</h4>

      <div class="form-group">
        <label for="Department">{{ 'FRONT_USER.WORK_COMPLETION_FORM.DEPARTMENT' | translate }}</label>
        <input type="text" class="form-control" id="Department" name="Department" formControlName="Department"
          disabled />
      </div>

      <div class="form-group">
        <label for="RequestDate">{{ 'FRONT_USER.WORK_COMPLETION_FORM.REQUEST_DATE' | translate }}</label>
        <input class="form-control" #datepickerMDY="bsDatepicker" bsDatepicker formControlName="RequestDate"
          [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }" disabled>
      </div>

      <div class="form-group">
        <label for="StartDate">{{ 'FRONT_USER.WORK_COMPLETION_FORM.START_DATE' | translate }}</label>
        <span class="red"> *</span>
        <input class="form-control" #datepickerMDY="bsDatepicker" bsDatepicker formControlName="StartDate"
          [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }">
        <div *ngIf="submitted && Validate.StartDate?.errors" class="red">
          <div *ngIf="Validate.StartDate?.errors?.required">{{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
      </div>
      <div class="form-group">
        <label for="EndDate">{{ 'FRONT_USER.WORK_COMPLETION_FORM.END_DATE' | translate }}</label>
        <span class="red"> *</span>
        <input class="form-control" #datepickerMDY="bsDatepicker" bsDatepicker formControlName="EndDate"
          [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }">
        <div *ngIf="submitted && Validate.EndDate?.errors" class="red">
          <div *ngIf="Validate.EndDate?.errors?.required">{{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
        <div *ngIf="ValidateDateComparsion && Validate.EndDate.value != null" class="red">
          <div *ngIf="ValidateDateComparsion">
            {{ 'FRONT_USER.WORK_COMPLETION_FORM.END_DATE_GREATER_ERROR' | translate }}
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="TotalCost">{{ 'FRONT_USER.WORK_COMPLETION_FORM.TOTAL_COST' | translate }}</label>
        <span class="red"> *</span>
        <div class="input-group">
        <input type="text" appOnlyDecimal  [onlydecimal]="true" class="form-control" id="TotalCost" name="TotalCost" formControlName="TotalCost" />
        <span class="input-group-addon">{{ 'FRONT_USER.SIGNDOLLAR' | translate}}</span>
      </div>
        <div *ngIf="submitted ||( Validate.TotalCost?.errors&&Validate.TotalCost?.dirty)" class="red ">
          <div *ngIf="Validate.TotalCost?.errors?.required">{{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
          <!-- <div *ngIf="Validate.TotalCost?.errors?.pattern"> {{'FRONT_USER.NUMBER_ERROR' | translate}}
          </div> -->
        </div>
      </div>

      <div class="form-group">
        <label for="WorkDescription">{{ 'FRONT_USER.WORK_COMPLETION_FORM.WORK_DESCRIPTION' | translate }}</label>
        <span class="red"> *</span>
        <textarea class="form-control" id="WorkDescription" name="WorkDescription"
          formControlName="WorkDescription"></textarea>
        <div *ngIf="submitted && Validate.WorkDescription?.errors" class="red">
          <div *ngIf="Validate.WorkDescription?.errors?.required">{{ 'FRONT_USER.This_Field_Is_Required' | translate }}
          </div>
        </div>
      </div>

    </div>
    <div class="form-container" *ngIf="!viewMode">
      <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>
      <div class="form-group">
        <label>{{'FRONT_USER.WORK_COMPLETION_FORM.BILL'|translate}}</label>
        <input type="file" class="form-control" MaxSizeInMB="5"
          accept=".DXF,.pdf,.gif, .jpg, .jpeg, .png, .bmp,.doc,.docx" id="BillInput" formControlName="Bill"
          (change)="AddAttachmentFile($event, Validate.Bill, 'CompletionForm_Bill', AttachmentType.WorkCompletionBill, 'BillPlanProgress','FRONT_USER.WORK_COMPLETION_FORM.BILL')" />
        <div class="upload-info">
          <span>{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
          <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
        </div>
        <div *ngIf="submitted && Validate.Bill?.errors" class="red">
          {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
          <!-- <div *ngIf="ValidateQualityControl.CertificateControl?.errors?.required">
            {{'FRONT_USER.This_Field_Is_Required' | translate}}</div> -->
        </div>
        <div class="progress">
          <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
            [style.width]="BillPlanProgress + '%'">
            <span class=""> {{BillPlanProgress}} % Complete</span>
          </div>
        </div>
      </div>


    </div>
    <div class="form-container" *ngIf="viewMode && billAttachmentExist ">
        <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>
      <div class="form-group">
          <div  class="read-uploaded">
            <label>{{'FRONT_USER.WORK_COMPLETION_FORM.BILL'|translate}}</label>
              <a [attr.href]="BillAttachmentUrl" target="_blank">
                  {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
                  <i class="icon-view-file"></i>
              </a>
          </div>
        </div>

    </div>

    <div class="form-container" formGroupName="QualityControl"
      *ngIf="QualityControlGate.includes(this.CurrServiceTypeId)">
      <h4 class="section-title">{{ 'FRONT_USER.WORK_COMPLETION_FORM.QUALITYINFO' | translate }}</h4>

      <div class="form-group">
        <label for="TestType">{{ 'FRONT_USER.WORK_COMPLETION_FORM.TEST_TYPE' | translate }}</label>
        <span class="red"> *</span>
        <input type="text" class="form-control" id="TestType" name="TestType" formControlName="TestTypeControl" />
        <div *ngIf="submitted && ValidateQualityControl.TestTypeControl?.errors" class="red ">
          <div *ngIf="ValidateQualityControl.TestTypeControl?.errors?.required">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
        <div *ngIf="ValidateQualityControl.TestTypeControl?.errors?.maxlength">
          {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
        </div>
      </div>

      <div class="form-group">
        <label for="TestDate">{{ 'FRONT_USER.WORK_COMPLETION_FORM.TEST_DATE' | translate }}</label>
        <span class="red"> *</span>
        <input class="form-control" #datepickerMDY="bsDatepicker" bsDatepicker formControlName="TestDateControl"
          [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }">
        <div *ngIf="submitted && ValidateQualityControl.TestDateControl?.errors" class="red">
          <div *ngIf="ValidateQualityControl.TestDateControl?.errors?.required">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
      </div>

      <div class="form-group" *ngIf="!viewMode">
        <label>{{'FRONT_USER.WORK_COMPLETION_FORM.CERTIFICATE'|translate}}</label>
        <span class="red"> *</span>
        <input type="file" class="form-control" MaxSizeInMB="5"
          accept=".DXF,.pdf,.gif, .jpg, .jpeg, .png, .bmp,.doc,.docx" id="CertificateInupt"
          formControlName="CertificateControl"
          (change)="AddAttachmentFile($event, ValidateQualityControl.CertificateControl,'CompletionForm_Certificate', AttachmentType.WorkCompletionCertificate, 'CertificatePlanProgress','FRONT_USER.WORK_COMPLETION_FORM.CERTIFICATE')" />
        <div class="upload-info">
          <span>{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
          <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
        </div>

        <div class="progress">
          <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
            [style.width]="CertificatePlanProgress + '%'">
            <span class=""> {{CertificatePlanProgress}} % Complete</span>
          </div>
        </div>
        <div *ngIf="submitted && ValidateQualityControl.CertificateControl?.errors" class="red">
          {{'FRONT_USER.This_Field_Is_Required' | translate}}
          <!-- <div *ngIf="ValidateQualityControl.CertificateControl?.errors?.required">
            {{'FRONT_USER.This_Field_Is_Required' | translate}}</div> -->
        </div>
      </div>



    </div>
    <div class="form-container" *ngIf="viewMode && QualityControlGate.includes(this.CurrServiceTypeId)&&CertificateAttachmentUrl != ''">
        <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>
    <div class="form-group">
      <div  class=" read-uploaded">
        <label>{{'FRONT_USER.WORK_COMPLETION_FORM.CERTIFICATE'|translate}}</label>
        <a [attr.href]="CertificateAttachmentUrl" target="_blank">
            {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
            <i class="icon-view-file"></i>
        </a>
      </div>
  </div>

    </div>


    <div class="form-container" formGroupName="FloatingCranesControl" *ngIf="CurrServiceTypeId == FloatingCranesGate">
      <h4 class="section-title">{{ 'FRONT_USER.WORK_COMPLETION_FORM.FLOATINGCRANESINFO' | translate }}</h4>

      <div class="form-group">
        <label
          for="FloatingCranesNameSelect">{{ 'FRONT_USER.WORK_COMPLETION_FORM.FLOATING_CRANES_NAME' | translate }}</label>
        <span class="red"> *</span>
        <select id="FloatingCranesNameSelect" name="FloatingCranesNameSelect" class="form-control"
          formControlName="FloatingCranesControl">
          <option [value]="''" selected>
            {{ 'FRONT_USER.WORK_COMPLETION_FORM.CHOOSE_FLOATING_CRANES_NAME' | translate }}
          </option>
          <ng-container *ngFor="let FloatingCranesName of FloatingCranesesNames">
            <option *ngIf="displayedLang==Languages.English" [value]="FloatingCranesName.Id">
              {{ FloatingCranesName.NameEN }}</option>
            <option *ngIf="displayedLang==Languages.Arabic" [value]="FloatingCranesName.Id">
              {{ FloatingCranesName.NameAR }}</option>
          </ng-container>
        </select>
        <div *ngIf="submitted && ValidateFloatingCranesControl.FloatingCranesControl?.value == ''" class="red">
          <div *ngIf="ValidateFloatingCranesControl.FloatingCranesControl?.value == ''">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
      </div>

      <div class="form-group">
        <label
          for="FloatingCranesTypeSelect">{{ 'FRONT_USER.WORK_COMPLETION_FORM.FLOATING_CRANES_TYPE' | translate }}</label>
        <span class="red"> *</span>
        <select id="FloatingCranesTypeSelect" name="FloatingCranesTypeSelect" class="form-control"
          formControlName="FloatingCranesTypeControl">
          <option [value]="''" selected>
            {{ 'FRONT_USER.WORK_COMPLETION_FORM.CHOOSE_FLOATING_CRANES_TYPE' | translate }}
          </option>
          <ng-container *ngFor="let FloatingCranesType of FloatingCranesTypes">
            <option *ngIf="displayedLang==Languages.English" [value]="FloatingCranesType.Id">
              {{ FloatingCranesType.NameEN }}</option>
            <option *ngIf="displayedLang==Languages.Arabic" [value]="FloatingCranesType.Id">
              {{ FloatingCranesType.NameAR }}</option>
          </ng-container>
        </select>
        <div *ngIf="submitted && ValidateFloatingCranesControl.FloatingCranesTypeControl?.value == ''"
          class="red">
          <div *ngIf="ValidateFloatingCranesControl.FloatingCranesTypeControl?.value == ''">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
      </div>

    </div>
  </fieldset >

    <div class="form-group" *ngIf="!viewMode">
      <button Confirmation (confirmationClick)="onSubmit()"  [disabled]="loading" class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate }}</button>
    </div>

  </form>
</div>

<!-- Confirmation -->
<div *ngIf="!showRequest&&!isErrorMessage&&!lockTaskErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.WORK_COMPLETION_FORM.ADMIN_SUCCESS_MESSAGE' | translate }}</p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a
        routerLink="/workspace">{{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<!-- error message -->
<div *ngIf="!showRequest&&isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>

    </div>
</div>

<!-- error message -->
<div *ngIf="!showRequest&&lockTaskErrorMessage" class="alert alert-warning" role="alert">
  <div class="alignC">
      <i class="icon-error"></i>
      <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
      <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>

  </div>
</div>
